import { useEffect, useState } from "react";

const ServerError = () => {
    const [started] = useState(Date.now());
    const [seconds, setSeconds] = useState<number | undefined>(undefined);

    const deadlineSeconds = 3;

    useEffect(() => {
        const getTime = () => {
            const time = Date.now() - started;
            setSeconds(Math.floor(time / 1000));
        };

        const interval = setInterval(() => getTime(), 1000);
        return () => clearInterval(interval);
    }, [started]);

    return (
        <>
            {seconds && seconds > deadlineSeconds &&
                <div className="server-error">
                    Greška na serveru. Verovatno već rešavamo problem. Ukoliko vidite istu ovu grešku za desetak minuta obratite se podršci.
                </div>
            }
        </>
    );
};

export default ServerError;
